// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --background-color: rgb(255, 246, 41);
    --red: rgb(226, 32, 38);
    --play-button-size: 100px;
    --triangle-size: 32px;
}

body {
    background-color: var(--background-color);
    font-family: 'Jost', sans-serif;
    margin: 50px;
    box-sizing: border-box;
}

#root {
    margin: auto;
    max-width: 100%;
}

section {
    margin-top: 20px;
    padding-top: 20px;
}

.italic {
    font-style: italic;
}

.block {
    border: var(--border-style);
    --border-style: 1px solid black;
}

.top-block {
    border-top: 1px solid black; /* Add a black bottom border */
    border-left: 1px solid black; /* Add a black bottom border */
    border-right: 1px solid black; /* Add a black bottom border */
}

.bottom-block {
    border-left: 1px solid black; /* Add a black bottom border */
    border-right: 1px solid black; /* Add a black bottom border */
    border-bottom: 1px solid black; /* Add a black bottom border */
}

p {
    margin: 0;
    padding: 0;
}

h1 {
    text-transform: uppercase;
    text-align: center;
    margin: 0;
    padding: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/style/app.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,+BAA+B;IAC/B,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B,EAAE,8BAA8B;IAC3D,4BAA4B,EAAE,8BAA8B;IAC5D,6BAA6B,EAAE,8BAA8B;AACjE;;AAEA;IACI,4BAA4B,EAAE,8BAA8B;IAC5D,6BAA6B,EAAE,8BAA8B;IAC7D,8BAA8B,EAAE,8BAA8B;AAClE;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,aAAa;AACjB","sourcesContent":[":root {\n    --background-color: rgb(255, 246, 41);\n    --red: rgb(226, 32, 38);\n    --play-button-size: 100px;\n    --triangle-size: 32px;\n}\n\nbody {\n    background-color: var(--background-color);\n    font-family: 'Jost', sans-serif;\n    margin: 50px;\n    box-sizing: border-box;\n}\n\n#root {\n    margin: auto;\n    max-width: 100%;\n}\n\nsection {\n    margin-top: 20px;\n    padding-top: 20px;\n}\n\n.italic {\n    font-style: italic;\n}\n\n.block {\n    border: var(--border-style);\n    --border-style: 1px solid black;\n}\n\n.top-block {\n    border-top: 1px solid black; /* Add a black bottom border */\n    border-left: 1px solid black; /* Add a black bottom border */\n    border-right: 1px solid black; /* Add a black bottom border */\n}\n\n.bottom-block {\n    border-left: 1px solid black; /* Add a black bottom border */\n    border-right: 1px solid black; /* Add a black bottom border */\n    border-bottom: 1px solid black; /* Add a black bottom border */\n}\n\np {\n    margin: 0;\n    padding: 0;\n}\n\nh1 {\n    text-transform: uppercase;\n    text-align: center;\n    margin: 0;\n    padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
